import React from 'react';
import { CheckIcon, GiftIcon, SparklesIcon } from 'lucide-react';
export function ValueSummary() {
  const items = [{
    icon: <CheckIcon className="w-5 h-5 text-brand-green shrink-0" data-id="element-268" />,
    label: 'Método completo paso a paso',
    value: '$318',
    status: 'Incluido',
    statusColor: 'text-brand-text'
  }, {
    icon: <SparklesIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-269" />,
    label: 'Sistema BetIQ (herramienta de análisis)',
    value: '$294',
    status: 'Incluido en paquetes con BetIQ',
    statusColor: 'text-brand-gold'
  }, {
    icon: <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-270" />,
    label: 'Bono #1: Gestión de Bankroll',
    value: '$197',
    status: 'GRATIS',
    statusColor: 'text-brand-green font-bold'
  }, {
    icon: <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-271" />,
    label: 'Bono #2: Fundamentos de apuestas',
    value: '$97',
    status: 'GRATIS',
    statusColor: 'text-brand-green font-bold'
  }];
  return <section className="w-full py-16 px-4 bg-brand-bg" data-id="element-272">
      <div className="max-w-3xl mx-auto bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_40px_rgba(212,168,67,0.15)]" data-id="element-273">
        <h3 className="text-2xl md:text-3xl text-center text-brand-gold font-bold mb-10" data-id="element-274">
          👉 Esto es lo que forma parte del sistema BetIQ:
        </h3>

        <div className="space-y-0" data-id="element-275">
          {items.map((item, i) => <div key={i} className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 border-b border-brand-gold/10 gap-2" data-id="element-276">
              <div className="flex items-center gap-3" data-id="element-277">
                {item.icon}
                <span className="text-brand-text font-medium" data-id="element-278">
                  {item.label}
                </span>
              </div>
              <div className="flex items-center gap-4 w-full sm:w-auto justify-between sm:justify-end pl-8 sm:pl-0" data-id="element-279">
                <span className="text-brand-muted line-through text-sm" data-id="element-280">
                  {item.value}
                </span>
                <span className={`${item.statusColor} text-sm min-w-[80px] text-right`} data-id="element-281">
                  {item.status}
                </span>
              </div>
            </div>)}
        </div>

        {/* Total value */}
        <div className="mt-8 text-center" data-id="element-282">
          <p className="text-2xl md:text-3xl font-heading font-bold text-brand-gold" data-id="element-283">
            Valor total del sistema: $900+ USD
          </p>
        </div>

        {/* Final line */}
        <p className="text-center text-brand-muted mt-6 text-base" data-id="element-284">
          Elige el paquete que mejor se adapte a ti para acceder al sistema
        </p>
      </div>
    </section>;
}